import { FC } from 'react'

import UserIcon from '@/assets/svg/UserIcon.svg'

type Props = {
  persons: string[] | null
}

const PassPersons: FC<Props> = ({ persons }) => {
  if (persons === null) {
    return
  }

  return (
    <div className="flex items-center gap-8">
      <div className="w-20 text-grey-40">
        <UserIcon />
      </div>
      <span className="inline-flex flex-wrap items-center text-grey-80">
        {persons.map((person, index) => (
          <span key={index} className="text-16 sm:text-14">
            {person}
            {index < persons.length - 1 && <span>,&nbsp;</span>}
          </span>
        ))}
      </span>
    </div>
  )
}

export { PassPersons }
